module.exports = "/_next/static/images/loading-45bbe0c876dde2302ded3820c8af703a.gif";